import BuildingCreateView from './BuildingFormView';

export default BuildingCreateView;
